import { ChangeDetectionStrategy, Component } from '@angular/core';

import { select } from '@ngxs/store';

import { CustomerState } from '@app/core/store/states/customer/customer.state';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { DisallowedOptimizationMessageComponent } from '../disallowed-optimization-message/disallowed-optimization-message.component';
import { DisallowedOptimizationTitleComponent } from '../disallowed-optimization-title/disallowed-optimization-title.component';

@Component({
  selector: 'adspt-disallowed-optimization-banner',
  templateUrl: 'disallowed-optimization-banner.component.html',
  styleUrls: ['disallowed-optimization-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NzAlertModule, DisallowedOptimizationMessageComponent, DisallowedOptimizationTitleComponent],
})
export class DisallowedOptimizationBannerComponent {
  readonly disallowStartOptimization = select(CustomerState.disallowStartOptimization);
}
